module.exports = __webpack_public_path__ + "img/towel.e4b8cbc0.png";